<template> 
  <v-menu    
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="200px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="dateRangeText"
        dense
        outlined
        hide-details="auto"
        :label="$t('label.time-period')" 
        readonly
        v-bind="attrs"
        v-on="on"
      />
    </template> 
    <v-date-picker 
      v-model="datePickerRange" 
      class="not-opacity"
      :range="range"
      :type="type" 
      :allowed-dates="allowedRange"
      locale="th-TH"
      locale-first-day-of-year="th-TH"
      no-title
    />
  </v-menu> 
</template>
<script>
import { getIsoDateFormat, firstlastMonth } from '@/plugins/time'

export default {
  props : {
    dateRange : {
      type:[Array,String],
      default:()=>[]
    },
    type : {
      type:[String,Boolean],
      default:()=>'date'
    },
    range : {
      type : Boolean,
      default:true
    },
    maxDays: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      datePickerRange : []
    }
  },  
  computed : {    
    dateRangeText () {
      if(this.range) {
        return this.datePickerRange[0]!=='' ? this.dateRange.join(' ~ ') : []
      } else {
        return this.datePickerRange
      }
    },
  }, 

  watch : {
    datePickerRange () {      
      if(this.type==="month") { 
        this.$emit('setDateRange',firstlastMonth(Date.parse(this.datePickerRange))) 
        return
      }

      if(this.range){ 
        if(new Date(this.datePickerRange[0])>new Date(this.datePickerRange[1])){
          this.$emit('setDateRange',[this.datePickerRange[1],this.datePickerRange[0]])
        } else { 
          if(this.datePickerRange[1]!==undefined){
            this.$emit('setDateRange',this.datePickerRange)
          }else {
            this.$emit('setDateRange',[this.datePickerRange[0],''])
          } 
        }
        return
      }

      this.$emit('setDateRange',[this.datePickerRange,this.datePickerRange]) 
    }
  },

  async mounted () {  
    this.datePickerRange = this.dateRange
    var date = new Date(),y = date.getFullYear(), m = date.getMonth()+1;  
    m = m > 9 ? m : `0${m}`
    var now = this.type==="month" ?  `${y}-${m}` :  getIsoDateFormat ()
    this.datePickerRange = this.range ? [this.datePickerRange[0] || now , this.datePickerRange[1] || now] : now 
  },

  methods: {
    allowedRange (date) {

      if (!this.maxDays) return true

      const [start, ] = this.datePickerRange;

      if (!start) return true;

      const startDate = new Date(start);
      const currentDate = new Date(date);

      const diff = Math.abs(currentDate - startDate);
      const diffDays = diff / (1000 * 60 * 60 * 24);

      return diffDays < this.maxDays;
    }
  }
}
</script>
<style scoped>
.not-opacity >>> .v-btn:not(.v-btn--text):not(.v-btn--outlined).v-btn--active:before{
  opacity: 0 !important;  
} 
</style>